import { useEffect, useState } from 'react';
import { CalendarDays, Bitcoin, ArrowRight, Lock } from 'lucide-react';
import { investmentsAPI } from '../../lib/api';
import { fmtEur } from './investmentShared';

export const OPP_STATUS = {
    upcoming: { label: 'Próximamente', cls: 'text-[#f3e3a6] border-[#d4af37]/40 bg-[#d4af37]/10' },
    open: { label: 'Abierta', cls: 'text-emerald-300 border-emerald-500/40 bg-emerald-500/10' },
    closed: { label: 'Cerrada', cls: 'text-slate-400 border-slate-600 bg-slate-800/60' },
};

export const daysUntil = (iso) => Math.ceil((new Date(iso + 'T00:00:00') - new Date()) / 86400000);
export const fmtTarget = (iso) => new Date(iso + 'T00:00:00').toLocaleDateString('es-ES', { day: '2-digit', month: 'long', year: 'numeric' });

export const OpportunityCard = ({ opp, onSelect, compact }) => {
    const st = OPP_STATUS[opp.status] || OPP_STATUS.upcoming;
    const d = daysUntil(opp.target_date);
    const closed = opp.status === 'closed';
    return (
        <div className="metal-frame rounded-2xl p-4 flex flex-col gap-2.5 min-w-0" data-testid={`opportunity-card-${opp.id}`}>
            <div className="flex items-start justify-between gap-2">
                <span className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[10px] font-bold uppercase tracking-wider ${st.cls}`} data-testid={`opportunity-status-${opp.id}`}>{st.label}</span>
                <span className="inline-flex items-center gap-1 text-[11px] text-[#c9c9cf]"><Bitcoin className="w-3 h-3 text-[#e8d48b]" />{opp.asset === 'BTC' ? 'BTC' : 'USDT TRC20'}</span>
            </div>
            <p className="text-white font-semibold text-sm leading-snug" data-testid={`opportunity-name-${opp.id}`}>{opp.name}</p>
            {!compact && opp.description && <p className="text-[#a3a3ab] text-xs leading-relaxed line-clamp-2">{opp.description}</p>}
            <div className="flex items-center gap-1.5 text-[11px] text-[#c9c9cf]">
                <CalendarDays className="w-3.5 h-3.5 text-[#e8d48b]" />
                <span data-testid={`opportunity-date-${opp.id}`}>{fmtTarget(opp.target_date)}</span>
                <span className="text-[#7c7c86]">· {d > 0 ? `en ${d} días` : d === 0 ? 'hoy' : 'fecha alcanzada'}</span>
            </div>
            {opp.min_amount ? <p className="text-[11px] text-[#a3a3ab]">Desde {fmtEur(opp.min_amount)}</p> : null}
            {onSelect && (
                <button type="button" onClick={() => onSelect(opp)} disabled={closed}
                    className={`mt-auto inline-flex items-center justify-center gap-1.5 h-8 rounded-full text-[11px] font-bold uppercase tracking-wider transition-colors ${closed ? 'border border-slate-700 text-slate-500 cursor-not-allowed' : 'metal-btn !tracking-wider'}`}
                    data-testid={`opportunity-reserve-${opp.id}`}>
                    {closed ? <><Lock className="w-3 h-3" /> Cerrada</> : <>Apartar <ArrowRight className="w-3 h-3" /></>}
                </button>
            )}
        </div>
    );
};

export const OpportunityCards = ({ onSelect, compact = false, limit }) => {
    const [items, setItems] = useState(null);
    useEffect(() => {
        investmentsAPI.opportunities().then(({ data }) => setItems(data.opportunities || [])).catch(() => setItems([]));
    }, []);
    if (!items || items.length === 0) return null;
    const visible = limit ? items.slice(0, limit) : items;
    return (
        <div className="relative mt-6" data-testid="opportunity-cards">
            <div className="metal-line mb-4" />
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#c9c9cf] mb-3">Próximas oportunidades · {items.length}</p>
            <div className={`grid gap-3 ${compact ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3' : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3'}`}>
                {visible.map((o) => <OpportunityCard key={o.id} opp={o} onSelect={onSelect} compact={compact} />)}
            </div>
        </div>
    );
};
